<template>
  <div class="odmik-vsebine-nastavtive-telefonija">
    <div>
      <div>
        <p class="navadno-besedilo">
          <b>
            Za izbrano mobilno številko lahko nastavite eno ali več preusmeritev klicev.
          </b>
          Preusmerjeni klici se obračunavajo skladno s cenikom – kot klic iz domačega T-2 omrežja v omrežje
          preusmerjene številke. Preusmeritve na mobilni telefoniji so možne le na slovenske telefonske številke.
        </p>
        <p class="navadno-besedilo">
          Preusmerjeno številko lahko vnesete v eni izmed naslednjih oblik: 003864064064, +3864064064 ali 064064064.
        </p>
      </div>

      <div v-if="preusmeritve !== null" v-loading="preusmeritve.loadingItems || preusmeritve.loadingSave" class="preusmeritve-container">
        <el-form :label-position="formaOrientacija" class="preusmeritve-form">
          <div
            v-for="(preusmeritev, index) in preusmeritve.preusmeritve"
            :key="index"
            class="preusmeritev-item"
          >
            <div class="preusmeritev-header-row">
              <h3 class="preusmeritev-naslov">{{ preusmeritev.name }}</h3>
              <div class="status-controls">
                <el-radio-group
                  v-model="preusmeritev.active"
                  @change="preusmeritve.reloadDisabledAttributes()"
                  class="status-radio-group"
                >
                  <el-radio
                    :label="true"
                    :disabled="preusmeritev.disabled === true"
                    class="status-radio"
                  >
                    Aktivno
                  </el-radio>
                  <el-radio
                    :label="false"
                    :disabled="preusmeritev.disabled === true"
                    class="status-radio"
                  >
                    Neaktivno
                  </el-radio>
                  <el-tooltip
                    v-if="preusmeritev.disabledMessage !== '' && $screen.width > 1250"
                    :content="preusmeritev.disabledMessage"
                    placement="top-end"
                  >
                    <el-icon
                      class="el-icon-info"
                      style="font-size: 18px; color: orange; cursor: pointer"
                    />
                  </el-tooltip>
                </el-radio-group>
                <div v-if="preusmeritev.disabledMessage !== '' && $screen.width <= 1250" class="pt-2 text-danger">
                  {{preusmeritev.disabledMessage}}
                </div>
              </div>
            </div>

            <template v-if="!preusmeritev.disabled && preusmeritev.active">
              <div class="form-row" v-if="preusmeritev.redirectOptions !== null">
                <div class="form-group">
                  <div class="input-container">
                    <span class="input-label">Tip preusmeritve:</span>
                    <el-select
                      v-model="preusmeritev.selectedRedirectOption"
                      placeholder="Izberite tip preusmeritve"
                      class="tip-select"
                      :disabled="preusmeritev.active === false || preusmeritev.disabled === true"
                      @change="preusmeritev.redrawRedirectOptions()"
                    >
                      <el-option
                        v-for="key in preusmeritev.redirectOptions"
                        :key="key.type"
                        :label="key.name"
                        :value="key.type"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
              <div
                class="form-row"
                v-if="preusmeritev.selectedRedirectOption === 'number'"
              >
                <div class="form-group">
                  <div class="input-container">
                    <span class="input-label">Telefonska številka:</span>
                    <div class="phone-input-wrapper">
                      <el-input
                        v-model="preusmeritev.number"
                        placeholder="Vpišite številko (npr. +38664064064)"
                        class="stevilka-input"
                        :disabled="preusmeritev.disabled === true || !preusmeritev.canEnableRedirectOptionNumber"
                        :maxlength="15 + (preusmeritev.number && preusmeritev.number.match(/\s/g) ? preusmeritev.number.match(/\s/g).length : 0)"
                        type="tel"
                        :class="GetPhoneNumberClass(preusmeritev)"
                      />
                    </div>
                    <div v-if="!preusmeritev.canEnableRedirectOptionNumber && preusmeritev.active" class="warning-message">
                      <i class="el-icon-warning"></i>
                      Prvo je potrebno aktivirati telefonsko storitev in potem boste lahko urejali preusmeritve.
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row"
                v-if="preusmeritev.selectedRedirectOption === 'voicemail'"
              >
                <div class="form-group">
                  <div class="input-container">
                    <span class="input-label">Glasovna pošta:</span>
                    <div v-if="preusmeritev.canEnableRedirectOptionVoicemail" class="voicemail-enabled">
                      <div class="voicemail-info">
                        <i class="el-icon-success voicemail-icon"></i>
                        <span class="voicemail-text">Glasovna pošta je aktivirana</span>
                      </div>
                    </div>
                    <div v-else class="voicemail-disabled">
                      <div class="warning-message">
                        <i class="el-icon-warning"></i>
                        Prvo je potrebno aktivirati glasovno pošto in potem boste lahko urejali preusmeritve.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row" v-if="preusmeritev.timeOptions && Object.keys(preusmeritev.timeOptions).length > 0">
                <div class="form-group">
                  <div class="input-container">
                    <span class="input-label">Čas odziva:</span>
                    <el-select
                      v-model="preusmeritev.time"
                      placeholder="Izberite čas odziva"
                      class="tip-select"
                    >
                      <el-option
                        v-for="(obj, key) in preusmeritev.timeOptions"
                        :key="key"
                        :label="obj"
                        :value="key"
                      />
                    </el-select>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </el-form>
        <div>
          <el-button
            type="primary"
            @click="nastaviPreusmeritve()"
            class="shrani-gumb"
            size="medium"
            :disabled="preusmeritve.loadingItems || preusmeritve.loadingSave"
            :loading="preusmeritve.loadingItems || preusmeritve.loadingSave"
          >
            SHRANI SPREMEMBE
          </el-button>
        </div>

        <div class="info-container">
          <InfoOknoPreusmeritve />
        </div>
      </div>

      <div v-if="podatkiOSim !== null">
        <GlasovnaPosta
          :podatki-o-sim="podatkiOSim"
          :izbranaTelefonska="izbranaTelefonska"
          v-on:posodobiPreusmeritve="preusmeritve.loadData(true)"
          :sap="sap"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {Checkbox, Button, Select, Option, Input, Loading, Collapse, CollapseItem, Tooltip} from 'element-ui'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {PhoneNumberValidator} from 'src/assets/js/globalne_funkcije/GlobalnoTelefonija/PhoneNumberValidator.js'
import ClientAgent from '../../../../../../assets/js/clientAgent'
import InfoOknoPreusmeritve from './InfoOknoPreusmeritve.vue'
import GlasovnaPosta from '../GlasovnaPosta.vue'
import PrikazPogodbe from '../../../Naroci/PrikazPogodbe.vue'
import TelefonskaStevilka from '../../../../../../assets/js/Prikljucek/Telefonija/Umts/TelefonskaStevilka'

export default {
  name: 'PreusmeritevMobilnaTelefonija',
  mixins: [PrikazVsebine],
  data () {
    return {
      formaOrientacija: 'left',
      klicNaCakanju: '',
      casovnaIzbira: '',
      mejnaSirina: 1200,
      clientAgent: null,
      seznamPreusmeritev: [],
      preusmeritve: null
    }
  },
  props: {
    izbranPrikljucek: String,
    izbranaTelefonska: String,
    seznamCasovnihIzbir: Array,
    podatkiOSim: {
      type: Object,
      required: true
    },
    sap: null
  },
  components: {
    PrikazPogodbe,
    GlasovnaPosta,
    InfoOknoPreusmeritve,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tooltip.name]: Tooltip
  },
  created () {
    this.clientAgent = new ClientAgent()
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.initPreusmeritve()
  },
  methods: {
    initPreusmeritve () {
      this.preusmeritve = TelefonskaStevilka.getInstance(
        Number(this.izbranPrikljucek),
        this.izbranaTelefonska,
        this.podatkiOSim.idSimKartica
      ).preusmeritve
      this.preusmeritve.loadData(true)
    },
    async nastaviPreusmeritve () {
      try {
        await this.preusmeritve.save()
        this.ShowSuccessMessage({message: 'Preusmeritve uspešno posodobljene.'})
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    GetPhoneNumberClass (redirectElement) {
      if (redirectElement.active === true &&
        redirectElement.type === 'number' &&
        redirectElement.number !== null &&
        redirectElement.number !== '' &&
        !PhoneNumberValidator.methods.ValidateSLOMobileNumber(redirectElement.number) &&
        !PhoneNumberValidator.methods.ValidateSLOFixNumber(redirectElement.number)) {
        return 'invalid-phone-number'
      } else {
        return ''
      }
    }
  },
  watch: {
    izbranaTelefonska: function () {
      if (this.izbranaTelefonska !== null) {
        this.initPreusmeritve()
      }
    }
  }
}
</script>
<style scoped src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveMobilnaTelefonija/Preusmeritve.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveMobilnaTelefonija/PreusmeritevMobilnaTelefonija.vue